import React from 'react';
import { TimecardSummaryData } from '../../shared/types.js';
import Button from './Button';
import { DownloadIcon } from './icons';
import { useTimeClock } from '../hooks/useTimeClock';

interface Props {
  data: TimecardSummaryData;
}

const TimecardSummaryReport: React.FC<Props> = ({ data }) => {
    const { companySettings } = useTimeClock();
    const handlePrint = () => {
        window.print();
    };
    return (
        <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 md:p-8 rounded-lg shadow-lg text-gray-900 dark:text-white">
            <style>
            {`
                @media print {
                    .print-area {
                        box-shadow: none !important;
                        padding: 0 !important;
                        background-color: transparent !important;
                        font-family: 'Times New Roman', serif;
                    }
                    .print-area, .print-area *, .print-text-black, .print-text-black * {
                        color: black !important;
                    }
                    .print-border-black {
                        border-color: black !important;
                    }
                }
                .report-grid {
                    grid-template-columns: 2fr repeat(4, 1fr);
                }
            `}
            </style>
            <div className="print-area text-sm">
				<div className="flex justify-between print-text-black dark:">
					<span><strong>Date Range:</strong> {data.dateRange}</span>
					<span><strong>Printed:</strong> {data.generatedAt}</span>
				</div>
                <div className="text-center print-text-black my-4">
                    <h2 className="text-2xl font-bold">Summary Period Report</h2>
                    <p className="text-lg">{companySettings.companyName}</p>
                    <p className="text-sm dark: print-text-black">{companySettings.companyAddress}</p>
                </div>
                <div className="my-6">
                    <div className="grid report-grid gap-x-4 font-bold border-b border-current dark: print-text-black">
                        <div className="text-left">Name</div>
                        <div className="text-right">Unpaid</div>
                        <div className="text-right">Base Time</div>
                        <div className="text-right">Over Time</div>
                        <div className="text-right">Total Paid Time</div>
                    </div>
                </div>
                <div className="space-y-1 print-text-black">
                    {data.employeeSummaries.map(summary => (
                        <div key={summary.employeeId} className="grid report-grid gap-x-4">
                            <div>{summary.employeeName}</div>
                            <div className="font-mono text-right">{summary.unpaid > 0 ? summary.unpaid.toFixed(2) : ''}</div>
                            <div className="font-mono text-right">{summary.regular.toFixed(2)}</div>
                            <div className="font-mono text-right">{summary.ot > 0 ? summary.ot.toFixed(2) : ''}</div>
                            <div className="font-mono text-right font-bold">{summary.totalPaid.toFixed(2)}</div>
                        </div>
                    ))}
                </div>
                <div className="grid report-grid gap-x-4 mt-4 pt-2 border-t border-gray-300 dark:border-gray-500 print-border-black">
                    <div className="font-bold text-lg print-text-black">Total Hours</div>
                    <div className="font-mono text-right font-bold text-lg print-text-black">{data.totals.unpaid > 0 ? data.totals.unpaid.toFixed(2) : ''}</div>
                    <div className="font-mono text-right font-bold text-lg print-text-black">{data.totals.regular.toFixed(2)}</div>
                    <div className="font-mono text-right font-bold text-lg print-text-black">{data.totals.ot > 0 ? data.totals.ot.toFixed(2) : ''}</div>
                    <div className="font-mono text-right font-bold text-lg print-text-black">{data.totals.totalPaid.toFixed(2)}</div>
                </div>
            </div>
        </div>
    );
};

export default TimecardSummaryReport;